import PropTypes from 'prop-types';
import { Button, Stack, styled, Typography, Tooltip, Box } from '@mui/material';
import RpCheckboxGrid from 'components/commons/RpCheckboxGrid';
import RpCheckbox from 'components/commons/RpCheckbox';
import InfoIcon from '@mui/icons-material/InfoOutline';

const StyledButton = styled(Button)({
    letterSpacing: '0.46px',
    fontSize: 14,
});

function RpCheckboxOptions(props) {
    return (
        <>
            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                <Stack direction="row" spacing={1}>
                    <Typography variant="text1" sx={{ paddingBottom: '4px' }} gutterBottom>{props.title}</Typography>
                    {
                        props.tooltip &&
                            <Tooltip
                                title={props.tooltip}
                                arrow
                                placement="right"
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: 240,
                                            lineHeight: 1.5,
                                            fontSize: '11px',
                                            padding: 1.5,
                                        }
                                    },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5, cursor: 'pointer' }}>
                                    <InfoIcon fontSize="medium" sx={{ color: 'action.active', fontSize: '18px' }} />
                                </Box>
                            </Tooltip>
                    }
                </Stack>
                <Stack direction="row" spacing={1}>
                    <StyledButton
                        size="small"
                        onClick={props.selectAll}
                        disabled={props.selected.length === props.options.length}
                    >
                        Select All
                    </StyledButton>
                    <StyledButton
                        size="small"
                        onClick={props.clearAll}
                        disabled={props.selected.length === 0}
                    >
                        Clear Selected
                    </StyledButton>
                </Stack>
            </Stack>
            <Stack spacing={1}>
                <RpCheckboxGrid
                    columnSize={props.columnSize}
                    spacing={0}
                    width={props.width}
                >
                    {props.options.map((option) => (
                        <RpCheckbox
                            value={option.value}
                            label={option.label}
                            checked={props.selected.includes(option.value)}
                            onChange={() => props.onChange(option.value)}
                            key={option.value}
                            icon={option.icon}
                        />
                    ))}
                </RpCheckboxGrid>
            </Stack>
        </>
    );
}

RpCheckboxOptions.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    columnSize: PropTypes.number,
    selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    onChange: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
    selectAll: PropTypes.func.isRequired,
};

export default RpCheckboxOptions;